import { SUGGESTED_PACK } from 'enums';
import { ATTRIB } from 'constants/test';
import { t } from 'services/i18n.service';
import { createHtml } from 'utils/helpers';
import { formatSecondsAsMinutesSecondsLabel } from 'utils/time.util';
import Chip, { ChipVariant } from 'components/ui/Chip';
import { Suggestion } from 'interfaces/setting.interface';

const CHIP_VARIANT: Record<SUGGESTED_PACK, ChipVariant> = {
  [SUGGESTED_PACK.CREATE_NEW_HABIT]: 'info',
  [SUGGESTED_PACK.LIBRARY]: 'warning',
  [SUGGESTED_PACK.HABIT_PACK]: 'success'
};

const ActivitySuggestion = ({
  suggestion
}: {
  readonly suggestion: Suggestion;
}) => {
  const { name, duration, where, pack_title, completionRequirements } =
    suggestion;

  const hasCompletionRequirements = Boolean(
    completionRequirements && completionRequirements.trim().length > 0
  );

  const secondaryText = hasCompletionRequirements
    ? completionRequirements
    : t('pack_suggestion_duration', {
        duration: formatSecondsAsMinutesSecondsLabel(duration)
      });

  return (
    <div
      data-testid={ATTRIB.DATA_TESTID.ACTIVITY_SUGGESTION_WRAPPER}
      className='w-full flex flex-col ~gap-0.5/1 ~py-1/1.5 ~px-2/3 cursor-pointer border rounded-md ~mb-1/2 dark:bg-secondary-dark-300 dark:hover:bg-secondary-dark-400 dark:border-secondary-dark-500 bg-gray-100 hover:bg-gray-200 group text-black dark:text-secondary-dark-900 relative'
      style={{
        boxShadow: '4px -4px 6px -1px rgba(0, 0, 0, 0.1)'
      }}>
      <p className='w-fit max-w-full text-xs truncate'>
        {createHtml(
          t(
            where === SUGGESTED_PACK.CREATE_NEW_HABIT
              ? 'create_new_habit_name'
              : 'use_habit_template_name_duration',
            {
              name
            }
          )
        )}
      </p>
      <div className='w-fit flex items-center gap-2'>
        <p className='w-full text-[0.64rem] truncate'>{secondaryText}</p>
        <Chip
          text={where}
          variant={CHIP_VARIANT[where]}
          size='xs'
          className='capitalize min-w-max'
        />
      </div>
      {where !== SUGGESTED_PACK.CREATE_NEW_HABIT && pack_title && (
        <p className='absolute top-1.5 right-1 text-[0.55rem] bg-green-600 px-1.5 py-0.5 rounded text-white hidden group-hover:inline-flex'>
          {pack_title}
        </p>
      )}
    </div>
  );
};

export default ActivitySuggestion;
